/** @file ShapeFill */
// From https://github.com/tldraw/tldraw/blob/8bbfe91e8805198827a48c5410d7e741f416ac1d/packages/tldraw/src/lib/shapes/shared/ShapeFill.tsx
import type { TLDefaultColorStyle, TLDefaultColorTheme, TLDefaultFillStyle } from '@tldraw/editor'
import { memo } from 'react'

interface ShapeFillProps {
  d: string
  fill: TLDefaultFillStyle
  color: TLDefaultColorStyle
  theme: TLDefaultColorTheme
}

const ShapeFill = memo(function ShapeFill({ theme, d, color, fill }: ShapeFillProps) {
  switch (fill) {
    case 'none': {
      return null
    }
    case 'solid': {
      return <path fill={theme[color].semi} d={d} />
    }
    case 'semi': {
      return <path fill={theme.solid} d={d} />
    }
    case 'fill': {
      return <path fill={theme[color].fill} d={d} />
    }
    case 'pattern': {
      // For now, we don't support patterns, fallback to semi
      return <path fill={theme.solid} d={d} />
    }
    default: {
      return null
    }
  }
})
export { ShapeFill }
